import * as Yup from "yup";

export const validationSchema = Yup.object({
    apiKey: Yup
        .string()
        .required("Required"),
    apiSecret: Yup
        .string()
        .required("Required"),
    fromEmail: Yup
        .string()
        .required("Required"),
    // fromName: Yup
    //     .string()
    //     .required("Required"),
    // replyName: Yup
    //     .string()
    //     .required("Required"),
    // replyEmail: Yup
    //     .string()
    //     .required("Required"),
    apiEndpoint: Yup
        .string()
        .required("Required"),

})

export const initialValues = {
    apiKey: "",
    apiSecret: "",
    fromEmail: "",
    fromName: "",
    replyName: "",
    replyEmail: "",
    apiEndpoint: "",
}